import {utilHelper} from "../../_helpers";
import {
    SUCCESSFUL_ASSIGNED_PRICE_LABEL,
    SUCCESSFUL_REMOVE_ASSIGNED_PRICE_LABEL,
    SUCCESSFUL_TRANSLATION_LABEL
} from "../../../components/i18n/i18n";

const relativeUrl = '/api/product'

export const productService = {
    search,
    getOptions,
    getItem,
    syncFirebase,
    saveItem,
    updateItem,
    deleteItem,
    translate,
    assignPriceManually,
    removeAssignPriceManually,
};


function search(offset, max, dataFilter) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: dataFilter, showAlert: false })
}

function getOptions(dataFilter) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getOptions`, 'POST', { data: dataFilter, showAlert: false } )
}

function syncFirebase(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncFirebase`, 'POST', { data: data, showAlert: true } )
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}

function translate(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}

function assignPriceManually(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/assignPriceManually/${id}`, 'PUT', { data: data, message:SUCCESSFUL_ASSIGNED_PRICE_LABEL });
}

function removeAssignPriceManually(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/removeAssignPriceManually/${id}`, 'PUT', { data: data, message:SUCCESSFUL_REMOVE_ASSIGNED_PRICE_LABEL });
}